/**
 * Created by Ivan on 23.01.2026
 */

const Leagues = function () {
    this.league = this.calcLeague();

    cleverapps.user.on("changePhysicalLevel", this.sendLeagueRating.bind(this), this);
    cleverapps.user.on("updateLeague", this.updateLeague.bind(this), this);
};

Leagues.prototype.updateLeague = function (silent) {
    const newLeague = this.calcLeague();
    if (this.league === newLeague) {
        return;
    }

    this.league = newLeague;

    if (!silent) {
        this.wantsLeaguesUpgradeWindow = true;
    }
};

Leagues.prototype.calcLeagueRating = function () {
    return cleverapps.user.getHumanReadableNumber() + (cleverapps.user.currentPhysicalLevel.progress || 0);
};

Leagues.prototype.calcLeague = function () {
    let league = 0;

    while (league < Leagues.LEVELS_BORDERS.length && Leagues.LEVELS_BORDERS[league] && this.calcLeagueRating() > Leagues.LEVELS_BORDERS[league]) {
        league++;
    }

    return league;
};

Leagues.prototype.sendLeagueRating = function () {
    this.updateLeague();

    if (cleverapps.flags.nomulti) {
        return;
    }

    connector.multi.leagues.postRating(`${cleverapps.config.name}_${this.league}`, this.calcLeagueRating());
};

Leagues.prototype.onChangeLeague = function (f) {
    if (cleverapps.flags.nomulti) {
        f();
        return;
    }
    
    delete this.wantsLeaguesUpgradeWindow;

    cleverapps.focusManager.compound(f, [
        function (f) {
            new LeaguesUpgradeWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        },

        function (f) {
            new LeaguesWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    ]);
};

Leagues.prototype.isAvailable = function () {
    return levels.user.checkAvailable(cleverapps.config.availables.LEADER_BOARD);
};

cleverapps.InitByFeature["leagues"] = function () {
    cleverapps.leagues = new Leagues();
};

Leagues.LEVELS_BORDERS = [30, 60, 100, 200, 500, 1000, false];